import React from 'react';
import useReveal from '../hooks/useReveal';
import useSeo from '../hooks/useSeo';
import IndustriesGrid from '../components/IndustriesGrid';
import GlobalGrowth from '../components/GlobalGrowth';
import CTA from '../components/CTA';

export default function Industries() {
  useReveal('industries');
  useSeo({ title: 'Industries | Interscope Ads', description: 'Performance marketing across Apps, Gaming, Fintech, E-commerce, Entertainment, Travel, SaaS and Lifestyle.' });
  return (
    <main className="pt-32">
      <section className="relative max-w-7xl mx-auto px-5 md:px-8 pb-10 text-center">
        <span className="reveal inline-block mb-3 text-xs font-semibold tracking-[0.25em] uppercase text-[#2563eb]">Industries</span>
        <h1 className="reveal font-display text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.08] max-w-3xl mx-auto">
          Built for Different <span className="text-gradient">Growth Challenges</span>
        </h1>
        <p className="reveal mt-6 text-slate-600 text-lg max-w-2xl mx-auto">
          Deep expertise across the verticals where performance and measurable outcomes matter most.
        </p>
      </section>

      <section className="relative max-w-7xl mx-auto px-5 md:px-8 pb-8">
        <IndustriesGrid />
      </section>

      <GlobalGrowth />
      <CTA />
    </main>
  );
}
